import {cachedFetch} from "../../utils/cachedFetch";


export const fetchIcons = () => {
	const url = global.config.server_path+'design_resource/get_icons';	
	return cachedFetch(url, {method : 'GET', credentials : 'include'})
}